import React from 'react';
import { Helmet } from 'react-helmet';
import LinkCards from '../components/sections/LinkCards';

export default function HomePage() {
    return (
        <main className="overflow-hidden">
            <Helmet htmlAttributes={{ lang: 'en' }}>
                <meta charSet="utf-8" />
                <title>About Us | Air Products</title>
                <meta name="description" content="" />
            </Helmet>

            <LinkCards />
        </main>
    );
}